import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Button, List } from "antd";
import moment from "moment";
import NoneData from "../common/NoneData";
export class ExerRecordIndex extends Component {
  state = {
    curPage: 1,
    BusType: 0,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.onLoadExerRecord();
  }
  onLoadExerRecord() {
    this.props.actions.fetchGetStudentPraticeList({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      BusType: this.state.BusType,
    })
  }
  onTypeClick(BusType) {
    this.setState({
      curPage: 1,
      BusType,
    }, () => {
      this.onLoadExerRecord();
    })
  }
  renderItem(item, key) {
    const typeTxt = item.BusType === 1 ? "章节练习" : item.ExamPaperType === 0 ? "模拟试卷" : "历年真题";
    return (
      <div key={key} className="exer-record-item">
        <h1>
          <p>
            <span>【{typeTxt}】</span><span>{item.Title}</span>
          </p>
          <p>
            {moment(new Date(item.EndTime)).format("YYYY-MM-DD HH:mm:ss")}
          </p>
        </h1>
        <div className="btns">
          {
            item.Valid === 0 && <Button className="continue" type="theme" onClick={() => {
              if (item.BusType === 1) {
                this.props.history.push(`/ques/chapter/continue?ID=${item.BusID}`);
              } else {
                this.props.history.push(`/ques/exam/continue/${item.BusID}-${item.ID}`);
              }

            }}>继续做题</Button>
          }
          {
            item.Valid === 1 && <Button className="check" type="theme2" onClick={() => {
              if (item.BusType === 1) {
                this.props.history.push(`/ques/chapter/check?busId=${item.BusID}&resultId=${item.ID}`);
              } else {
                this.props.history.push(`/ques/exam/check/${item.BusID}-${item.ID}`);
              }
            }}>查看</Button>
          }
          {
            item.BusType !== 1 && item.Valid === 1 && <Button style={{ marginLeft: 20 }} className="check" type="theme" onClick={() => {
              this.props.history.push(`/ques/exam/page/${item.BusID}`);
            }}>
              重新做题
            </Button>
          }
        </div>
      </div>
    )
  }
  render() {
    let { fetchGetStudentPraticeListPending,
      fetchGetStudentPraticeListSuccess,
      fetchGetStudentPraticeListTotal } = this.props.center;
    const { BusType } = this.state;
    return (
      <div className="center-exer-record-index">
        <div className="inner">
          <div className="type">
            <div className={BusType === 0 ? "type-item-active" : "type-item"} onClick={this.onTypeClick.bind(this, 0)}>全部</div>
            <div className={BusType === 1 ? "type-item-active" : "type-item"} onClick={this.onTypeClick.bind(this, 1)}>章节练习</div>
            <div className={BusType === 3 ? "type-item-active" : "type-item"} onClick={this.onTypeClick.bind(this, 3)}>历年真题</div>
            <div className={BusType === 2 ? "type-item-active" : "type-item"} onClick={this.onTypeClick.bind(this, 2)}>模拟考试</div>
          </div>
          {
            fetchGetStudentPraticeListSuccess && fetchGetStudentPraticeListSuccess.length > 0 &&

            <div className="exer-record-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadExerRecord();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetStudentPraticeListTotal,
                  pageSize: 5,
                }}
                loading={fetchGetStudentPraticeListPending}
                dataSource={fetchGetStudentPraticeListSuccess}
                renderItem={(item, key) => this.renderItem(item, key)}
              />
            </div>
          }
          {
            fetchGetStudentPraticeListSuccess && fetchGetStudentPraticeListSuccess.length === 0 &&
            <div className="noneData">
              <NoneData type={2} />
            </div>
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecordIndex);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordIndex.js